export default __webpack_public_path__ + "static/media/hht1_song_16.1b31faf6.png";